import * as tinycolor from 'tinycolor2';
import { IThemePalette, ThemeColor } from '../model/theme.model';

function getColorObject(color: tinycolor.Instance, name: string): ThemeColor {
  return {
    name,
    hex: color.toHexString(),
    darkContrast: color.isLight(),
  };
}

function multiply(
  rgb1: tinycolor.ColorFormats.RGB,
  rgb2: tinycolor.ColorFormats.RGB
): tinycolor.Instance {
  rgb1.r = Math.floor((rgb1.r * rgb2.r) / 255);
  rgb1.g = Math.floor((rgb1.g * rgb2.g) / 255);
  rgb1.b = Math.floor((rgb1.b * rgb2.b) / 255);
  const { r, g, b } = rgb1;

  return tinycolor(`rgb ${r} ${g} ${b}`);
}

function computeColors(colorPalette: IThemePalette): ThemeColor[] {
  return [
    getColorObject(tinycolor(colorPalette.lighter), '100'),
    getColorObject(tinycolor(colorPalette.default), '500'),
    getColorObject(tinycolor(colorPalette.darker), '700'),
  ];
}

function updateTheme(colorPaletteShades: ThemeColor[], theme: string) {
  colorPaletteShades.forEach((colorShade) => {
    document.documentElement.style.setProperty(
      `--theme-${theme}-${colorShade.name}`,
      colorShade.hex
    );
    document.documentElement.style.setProperty(
      `--theme-${theme}-contrast-${colorShade.name}`,
      colorShade.darkContrast ? 'rgba(black, 0.87)' : 'white'
    );
  });
}

export function useThemeColorPalette(color: IThemePalette, colorName: string) {
  const colorPaletteShades = computeColors(color);
  updateTheme(colorPaletteShades, colorName);
}
